import React, { useRef, useState } from "react";
import "../styles/LiquidGlass.css";
import HeroLiquid from "../components/hero/HeroLiquid.js";
import FeaturesLiquid from "../components/features/FeaturesLiquid.js";
import MainFeatureLiquid from "../components/features/MainFeatureLiquid.js";
import PricingLiquid from "../components/pricing/PricingLiquid.js";
import TestimonialLiquid from "../components/testimonials/TestimonialLiquid.js";
import FAQLiquid from "../components/misc/FAQLiquid.js";
import FooterLiquid from "../components/misc/FooterLiquid.js";
import ContactFormLiquid from "../components/forms/ContactFormLiquid.js";
import ContactDetailsLiquid from "../components/cards/ContactDetailsLiquid.js";
import professionalImageSrc from "../../../images/professional.png";
import getStartedImageSrc from "../../../images/getStarted.png";
import { ReactComponent as WhatsAppIcon } from "../../../images/whatsapp-icon.svg";

export default function ProductLandingPageLiquid() {
  const homeRef = useRef(null);
  const contactRef = useRef(null);
  const servicesRef = useRef(null);
  const pricingRef = useRef(null);
  const getStartedRef = useRef(null);
  const faqRef = useRef(null);
  const reviewsRef = useRef(null);

  const [planSelected, setPlanSelected] = useState("");

  const onScroll = (route) => {
    switch (route) {
      case "Home":
        homeRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "Contact":
        contactRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "Services":
        servicesRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "Pricing":
        pricingRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "GetStarted":
        getStartedRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "FAQs":
        faqRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "Reviews":
        reviewsRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="app-liquid-glass">
      {/* Floating Background Elements */}
      <div
        className="floating-element"
        style={{
          top: "10%",
          left: "5%",
          width: "60px",
          height: "60px",
          animationDelay: "0s",
        }}
      ></div>
      <div
        className="floating-element"
        style={{
          top: "20%",
          right: "10%",
          width: "40px",
          height: "40px",
          animationDelay: "-3s",
        }}
      ></div>
      <div
        className="floating-element"
        style={{
          top: "60%",
          left: "8%",
          width: "80px",
          height: "80px",
          animationDelay: "-6s",
        }}
      ></div>
      <div
        className="floating-element"
        style={{
          bottom: "20%",
          right: "5%",
          width: "50px",
          height: "50px",
          animationDelay: "-9s",
        }}
      ></div>

      <div ref={homeRef} id="hero" />
      <HeroLiquid onClick={onScroll} />

      <div ref={servicesRef} id="features" />
      <FeaturesLiquid />

      <MainFeatureLiquid imageSrc={professionalImageSrc} />

      <div ref={pricingRef} id="pricing" />
      <PricingLiquid
        onContactClick={() => {
          setPlanSelected("I'm interested in getting a custom quote");
          onScroll("Contact");
        }}
      />

      <div ref={getStartedRef} />
      <MainFeatureLiquid imageSrc={getStartedImageSrc} reverse={true} />

      <div ref={reviewsRef} id="testimonials" />
      <TestimonialLiquid />

      <div ref={faqRef} />
      <FAQLiquid />

      <div ref={contactRef} id="contact" />
      <ContactFormLiquid message={planSelected} />

      <ContactDetailsLiquid />

      <FooterLiquid onClick={onScroll} />
    </div>
  );
}
